import { isUndefined } from "lodash";

export const generateBasicAuthProject = (token) => {
  return Buffer.from(`not-project:${token}`).toString("base64");
};
export const generateBasicAuthSendDocument = (token) => {
  console.log(token)
  return Buffer.from(`not-send-document:${token}`).toString("base64");
};
export const generateAuthHeaders = (opt = 0) => {
  let jwt = undefined
  try {
    jwt = JSON.parse(localStorage.token);
  } catch {}
  let headers = {
    Authorization: `Bearer ${jwt}`,
  };
  if (isUndefined(jwt)) {
    if (opt === 0) {
      const externToken = sessionStorage.getItem("extern-token");
      headers = {
        Authorization: `Basic ${generateBasicAuthProject(externToken)}`,
      };
    }
    if (opt === 1) {
      const externToken = sessionStorage.getItem("sent-document-token");
      headers = {
        Authorization: `Basic ${generateBasicAuthSendDocument(externToken)}`,
      };
    }
  }
  return headers;
};
